import {
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import {
  getMassItemQueue,
  retryMassItemProcess,
} from "../../../actions/itemTypeActions/ItemTypeActions"
import { RootStore } from "../../../Store"
import Pagination from "../utils/ResultsPagination"
import useStyles from "./BulkItemQueueTitleStyles"
interface BulkItemsRetriesListProps {
  statusSelected: string[]
}

const BulkItemsRetriesList = ({
  statusSelected,
}: BulkItemsRetriesListProps) => {
  const classes = useStyles()
  const [t] = useTranslation("global")
  const dispatch = useDispatch()
  const params = new URLSearchParams(window.location.search)
  let page = params.get("page")
  const location = useLocation()

  const itemTypeState = useSelector((state: RootStore) => state.itemType)
  const { massItems, loading, refresh } = itemTypeState

  const [currentPage] = useState<number>(
    massItems?.data.pageable.pageNumber ?? 0
  )
  const totalPages = massItems?.data.totalPages ?? 0

  const onRetry = (id: number, cancelProgrammedProcess: Boolean) => {
    dispatch(retryMassItemProcess(id, cancelProgrammedProcess))
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }
    return date.toLocaleString('en-US', options).replace(',', '')
  }

  useEffect(() => {
    const qParams: any = {
      paged: true,
      size: 10,
      page: page ? parseInt(page) - 1 : 0,
    }

    if (statusSelected.length > 0) {
      qParams.status = statusSelected
    }

    dispatch(getMassItemQueue(qParams))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusSelected, dispatch, location, refresh])
  return (
    <Paper elevation={3} className={classes.paper}>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow key="header" className={classes.tableHeader}>
              <TableCell>{t("items.id")}</TableCell>
              <TableCell>{t("items.type")}</TableCell>
              <TableCell>{t("items.categories")}</TableCell>
              <TableCell>{t("items.bulk-tag-parent")}</TableCell>
              <TableCell>{t("items.bulk-subtag")}</TableCell>
              <TableCell>{t("items.status")}</TableCell>
              <TableCell>{t("items.action")}</TableCell>
            </TableRow>
          </TableHead>
          {loading === "MASS_ITEM_QUEUE" ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={7}>
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {massItems?.data?.content?.map((item: any) => (
                <TableRow key={item.id}>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>{item.processName}</TableCell>
                  <TableCell>{item.itemTypeName}</TableCell>
                  <TableCell>{item.labelName}</TableCell>
                  <TableCell>{item.labelValueName}</TableCell>
                  <TableCell>
                    {item.status === "Programado" ? (
                      <div>
                        <div>{item.status}</div>
                        <div>{formatDate(item.runDate)}</div>
                      </div>
                    ) : (
                      item.status
                    )}
                  </TableCell>
                  {
                    item.status === "Programado" || item.status === "Error" ? (
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => onRetry(item.id, item.status==="Programado")}
                        >
                          {item.status === "Programado" ? t("items.cancel"): t("items.retry")}
                        </Button>
                      </TableCell>) : <TableCell></TableCell>
                  }
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      {totalPages > 1 && (
        <Pagination
          current={currentPage}
          path="/admin/bulk-item-update-queue"
          pagesNumber={totalPages}
        />
      )}
    </Paper>
  )
}

export default BulkItemsRetriesList
